import { render, staticRenderFns } from "./DirectClientDashboard.vue?vue&type=template&id=4be8e69f&"
import script from "./DirectClientDashboard.vue?vue&type=script&lang=js&"
export * from "./DirectClientDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports